import { classNames } from '../../lib/utils'

const variants = {
  primary: 'gradient-primary text-on-primary font-semibold shadow-sm hover:shadow-md',
  secondary: 'bg-surface-container-highest text-primary font-semibold',
  ghost: 'bg-transparent text-primary tracking-[0.05em] font-semibold',
  danger: 'bg-error text-on-error font-semibold',
}

const sizes = {
  sm: 'px-3.5 py-2 text-xs',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-6 py-3.5 text-sm',
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  type = 'button',
  onClick,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        'inline-flex items-center justify-center gap-2 rounded-md transition-all duration-150',
        'disabled:opacity-40 disabled:cursor-not-allowed',
        'active:scale-[0.98]',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
